import { BlockItemMedia } from '@/models/Blocks/Itens/block-item-media';
import { BlockItemType } from '@/models/Blocks/Itens/Types/block-item-type';
import { BlockSocialUrl } from '@/models/Blocks/Itens/Types/block-social-types';
import { SocialLikes } from '@/models/Social/social-likes';


export class BlockSocial extends BlockItemMedia {
    protected _name: string;
    protected _description?: string;
    protected _recordType?: string;
    protected _id: number|string;
    protected _urls: BlockSocialUrl;
    protected _profileImg?: string;
    protected _likes?: SocialLikes;
    protected _openModal: boolean = false;
    protected _hasVideo: boolean = false;
    protected _isVerified: boolean = false;

    public constructor(id: number|string, name: string) {
        super(BlockItemType.social);
        this._name = name;
        this._id = id;
        this._urls = {};
    }

    public get id(): number|string{
        return this._id;
    }

    public get profile(): string|undefined{
        return this._profileImg;
    }

    public set profile(value: string|undefined) {
        this._profileImg = value;
    }

    public get name(): string{
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get isVerified(): boolean {return this._isVerified;}

    public set isVerified(value: boolean) {this._isVerified = value;}

    public get likes(): SocialLikes|undefined{
        return this._likes;
    }

    public set likes(value: SocialLikes|undefined) {
        this._likes = value;
    }

    public get urls(): BlockSocialUrl{
        return this._urls;
    }

    public set urls(value: BlockSocialUrl) {
        //if not have post url set parter page
        if(value.page){
            this.url = value.page;
        }
        if(value.post){
            this.url = value.post;
        }
        this._urls = value;
    }

    public get openModal(): boolean{
        return this._openModal;
    }

    public set openModal(value: boolean) {
        this._openModal = value;
    }

    public get hasVideo(): boolean{
        return this._hasVideo;
    }

    public set hasVideo(value: boolean) {
        this._hasVideo = value;
    }

    public get description(): string|undefined{
        return this._description;
    }

    public set description(value: string|undefined) {
        this._description = value;
    }

    public get recordType(): string|undefined{
        return this._recordType;
    }

    public set recordType(value: string|undefined) {
        this._recordType = value;
    }

    public get mubData():string|undefined{
        return !this.blockName ? this._mub : JSON.stringify({
            t: 'socialpost',
            b: this.blockName,
            m:{
                socialPostId: this.id
            }
        });
    }

    public set mubData(value: string|undefined){
        this._mub = value;
    }

}